import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'get_houseRules_lodgingCancellationPolicy';

const lodgingCancellationPolicyQuery = `
query ${OPERATION_NAME}($arrivalDate: String, $unitUrl: String!, $isIpmNonGuaranteedPricing: Boolean) {
    houseRules(unitUrl: $unitUrl, arrivalDate: $arrivalDate, isIpmNonGuaranteedPricing: $isIpmNonGuaranteedPricing) {
        lodgingCancellationPolicy {
            datesDoNotQualifyForCancellationText
            freeCancellationDeadlineDate
            freeCancellationLabel
            policyPeriodTexts
            policyText
            undatedPolicyPeriodTexts
            undatedPolicyText
        }
    }
}`;

async function lodgingCancellationPolicyGraphQl({
    locale,
    arrivalDate,
    unitUrl,
    isIpmNonGuaranteedPricing
}) {
    try {
        return await graphqlQuery(
            OPERATION_NAME,
            lodgingCancellationPolicyQuery,
            {arrivalDate, unitUrl, isIpmNonGuaranteedPricing},
            locale
        );
    } catch (e) {
        return null;
    }
}

export default lodgingCancellationPolicyGraphQl;
export {lodgingCancellationPolicyGraphQl, OPERATION_NAME, lodgingCancellationPolicyQuery};
